module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/022-syria-f4b055b6973a7c2c7cacbb4285086a4d.svg";